import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { ModalService } from '../../../../shared/services/modal.service';
import { ClientFormComponent } from '../client-form/client-form.component';
import { ClientDto } from '../../../../api';

@Component({
  selector: 'app-edit-client-modal',
  standalone: true,
  imports: [CommonModule, ButtonModule, ModalComponent, ClientFormComponent],
  templateUrl: './edit-client-modal.component.html',
  styleUrl: './edit-client-modal.component.css',
})
export class EditClientModalComponent implements OnInit {
  private readonly modalService = inject(ModalService);

  @ViewChild(ClientFormComponent) formComponent!: ClientFormComponent;

  @Input() data?: {
    client: ClientDto;
    clients: ClientDto[];
    onConfirm: (formComponent: ClientFormComponent) => void;
  };

  client?: ClientDto;
  clients: ClientDto[] = [];
  isFormInvalid = true;

  ngOnInit() {
    this.client = this.data?.client;
    this.clients = this.data?.clients ?? [];
  }

  onValidityChange(isInvalid: boolean): void {
    this.isFormInvalid = isInvalid;
  }

  saveClient() {
    if (this.formComponent) {
      this.formComponent.markAllAsTouched();

      if (!this.formComponent.isValid()) {
        console.warn('Formularz nieprawidłowy');
        return;
      }

      if (this.data?.onConfirm) {
        this.data.onConfirm(this.formComponent);
      }
    }
  }
}
